import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { SpinnerStateService } from '../services/spinner-state.service';
import { UnityDirectStateService } from '../services/unity-direct-state.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  // Populate this array with list of url parts where the spinner is not required.
  skipSpinnerURLs = ['GetVehicleMaintenanceRepairsDetails', 'Book'];

  constructor(
    private spinnerStateService: SpinnerStateService,
    private udStateService: UnityDirectStateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const shouldSkipSpinner = this.skipSpinnerURLs.some((keyword: string) => {
      const regex = new RegExp(`\\b${keyword}\\b`); //strict match word
      return regex.test(req.url);
    });

    if (!shouldSkipSpinner && !this.udStateService.isNavInProgress) {
      this.spinnerStateService.show();
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!shouldSkipSpinner) {
          this.spinnerStateService.hide();
        }
      })
    );
  }
}
